import { useEffect, useState, useCallback } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { getAppCheckHeaders } from '../firebase';

const useAuthSession = ({ auth, setError }) => {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAuthLoading(false);
    });

    return () => unsubscribe();
  }, [auth]);

  const getAuthHeaders = useCallback(async () => {
    const headers = {};

    if (user) {
      const token = await user.getIdToken();
      headers.Authorization = `Bearer ${token}`;
    }

    if (process.env.NODE_ENV !== 'development') {
      const appCheckHeaders = await getAppCheckHeaders();
      Object.assign(headers, appCheckHeaders);
    }

    return { headers };
  }, [user]);

  const handleLogout = useCallback(async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Logout error:', error);
      setError('Failed to logout');
    }
  }, [auth, setError]);

  return {
    user,
    setUser,
    authLoading,
    getAuthHeaders,
    handleLogout,
  };
};

export default useAuthSession;
